import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import {
  HttpClient,
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { QuicklinkModule } from 'ngx-quicklink';

import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { AppGlobals } from '@app/app.global';
import {
  AuthService,
  AuthGuard,
  NoAuthGuard,
  appInitializer,
  ErrorInterceptor,
  LoaderInterceptor,
  TokenInterceptor,
  SharedService,
  CaseInterceptor,
  CaseService,
  LoaderService,
  translateHttpLoader,
  HeaderInterceptor,
  AdminGuard,
  NotPlayerGuard,
  EncodeHttpParamsInterceptor,
  PlayerGuard,
  LanguageInterceptor,
} from '@app/core';
import { HomeLayoutComponent, loginLayoutComponent, OnboardLayoutComponent } from '@app/layout';

import { SharedModule } from '@shared/shared.module';
import { APP_BASE_HREF } from '@angular/common';

@NgModule({
  declarations: [AppComponent, HomeLayoutComponent, loginLayoutComponent, OnboardLayoutComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    QuicklinkModule,
    ScrollingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpLoader,
        deps: [HttpClient],
      },
      extend: true,
    }),
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
      deps: [LoaderService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CaseInterceptor,
      multi: true,
      deps: [CaseService],
    },
    AppGlobals,
    AuthGuard,
    NoAuthGuard,
    AdminGuard,
    NotPlayerGuard,
    PlayerGuard,
    SharedService,
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
